import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthTokenService } from '../services/auth-token.service';
import { catchError, map, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { logout, silentClearSession } from '../state/auth/auth.actions';
import { LogoutType } from '../../shared/enums/logoutType.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authTokenService: AuthTokenService,
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const token = this.authTokenService.getToken();

    if (!token) {
      this.authTokenService.setRedirectUrl(state.url);
      this.router.navigate(['/login']);
      return of(false);
    }

    if (this.authTokenService.isAuthenticated()) {
      return this.authTokenService.refresh().pipe(
        map(({ accessToken }) => {
          this.authTokenService.storeToken(accessToken);
          return true;
        }),
        catchError((error) => {
          const code = error?.error?.code;
          if (code === 'WEB_PORTAL_ACCESS_DENIED') {
            this.authTokenService.clearToken();
            this.store.dispatch(silentClearSession());
            this.router.navigate(['/download']);
            return of(false);
          }

          return of(true);
        })
      );
    }

    // Try to refresh
    return this.authTokenService.refresh().pipe(
      map(({ accessToken }) => {
        this.authTokenService.storeToken(accessToken);
        return true;
      }),
      catchError((error) => {
        const code = error?.error?.code;
        if (code === 'WEB_PORTAL_ACCESS_DENIED') {
          this.authTokenService.clearToken();
          this.store.dispatch(silentClearSession());
          this.router.navigate(['/download']);
          return of(false);
        }

        this.authTokenService.clearToken();
        this.authTokenService.setRedirectUrl(state.url);
        this.router.navigate(['/login']);
        this.store.dispatch(logout({ source: LogoutType.Timeout }));
        return of(false);
      })
    );
  }
}
